import {CompetitorViewModel} from "./competitor-view-model";
import {CompetitorCompetitionsDomainModel} from "./competitor-competitions.domain-model";
import {CompetitorDomainModel} from "./competitor-domain-model";

export class CompetitorCompetitionsViewModel extends CompetitorViewModel {
  domainModel: CompetitorCompetitionsDomainModel;

  constructor(model: CompetitorDomainModel, isLight: Boolean, domainModel: CompetitorCompetitionsDomainModel, minFollowValue: Number) {
    super(model, isLight);
    this.domainModel = model;
    this.minFollowValue = minFollowValue;
  }

  get hasStandings(): Boolean {
    return this.domainModel.hasStandings;
  }

  get hasBrackets(): Boolean {
    return this.domainModel.hasBrackets;
  }

  get hasStats(): Boolean {
    return this.domainModel.hasStats;
  }

  get hasTransfers(): Boolean {
    return this.domainModel.hasTransfers;
  }

  get objectType() {
    return CompetitorViewModel.name;
  }

  get shouldRenderPopularityRank(): Boolean {
    const shouldRenderPopularityRank: Boolean = this.popularityRank && (this.popularityRank >= this.minFollowValue);

    return shouldRenderPopularityRank;
  }
}
